module.exports = __webpack_public_path__ + "img/ma-active.06686ce2.png";